import styled, { keyframes } from 'styled-components';
import SyncIcon from '../assets/sync.svg?react';

const SpinKeyframes = keyframes`
  to { -webkit-transform: rotate(360deg); }
`;

export const SyncAnimation = styled(SyncIcon)<{ $size?: string; $marginLeft?: string }>`
  fill: var(--color-text);
  background-color: transparent;
  display: inline-block;
  width: ${(props) => props.$size ?? '50px'};
  height: ${(props) => props.$size ?? '50px'};
  /* if spinner track is desired */
  /* border: 3px solid var(--color-spinner-background); */
  animation: ${SpinKeyframes} 2s linear infinite;
  ${(props) => props.$marginLeft && `margin-left: ${props.$marginLeft}`};
`;
